import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
import EditSecretsForm from "@/components/ConfigTemplates/EditSecretsForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditSecrets',
    props: {
        fileSource: null,
        template: null
    },
    setup(__props) {
        const props = __props;
        const title = computed(() => `Update File Source ${props.fileSource?.name} Secrets`);
        async function onUpdate(secretName, secretValue) {
            const { error } = await GalaxyApi().PUT("/api/file_source_instances/{uuid}", {
                params: { path: { uuid: props.fileSource.uuid } },
                body: {
                    secret_name: secretName,
                    secret_value: secretValue,
                },
            });
            if (error) {
                rethrowSimple(error);
            }
        }
        return { __sfc: true, props, title, onUpdate, EditSecretsForm };
    }
});
